export const environment = {
  production: false,
  apiURL: 'https://vetpay-clinic-api.imhotek.com.au',
  vet_pay_status: 'https://status.vetpay.com.au',
};
